import { render, staticRenderFns } from "./Destinations.vue?vue&type=template&id=1d408448&"
import script from "./Destinations.vue?vue&type=script&lang=js&"
export * from "./Destinations.vue?vue&type=script&lang=js&"
import style0 from "./Destinations.vue?vue&type=style&index=0&id=1d408448&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports